import { api, formatIDR, API_BASE } from "@/lib/api";

export const poLink = (token) => `${API_BASE}/public/po/${token}/pdf`;

// Buat link publik PO lalu buka WA supplier dengan link tersebut
export const sendPoWa = async (po) => {
  const { data } = await api.post(`/purchase-orders/${po.id}/share`);
  const phone = (po.supplier_phone || "").replace(/[^0-9]/g, "").replace(/^0/, "62");
  const lines = [`Halo ${po.supplier_name},`, "", `Purchase Order ${po.code}${po.revision ? ` (Revisi R${po.revision})` : ""}`,
    `Item: ${po.stock_name} (${po.category || "-"})`, `Qty: ${po.qty} ${po.unit}`, `Harga: ${formatIDR(po.unit_price)} / ${po.unit}`, `Total: ${formatIDR(po.total)}`,
    ...(po.parent_po_code ? [`Lanjutan dari ${po.parent_po_code}: ${po.notes || ""}`] : []), "", `Lihat PO (PDF): ${poLink(data.token)}`, "", "Mohon konfirmasi ketersediaan & pengiriman. Terima kasih."];
  window.open(`https://wa.me/${phone}?text=${encodeURIComponent(lines.join("\n"))}`, "_blank");
  return data.token;
};
